const codeSnippet: string = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"
 preserveAspectRatio="xMidYMid meet">

<rect width="100%" height="100%" fill="none" />

<g transform="translate(0,128) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M261 1173 c-24 -9 -63 -35 -86 -58 -60 -59 -75 -112 -75 -261 0 -67
-3 -129 -6 -138 -3 -9 -23 -20 -44 -26 -41 -11 -56 -35 -45 -70 4 -12 21 -24
45 -30 21 -6 41 -17 44 -26 3 -9 6 -71 6 -138 0 -149 15 -202 75 -261 53 -53
115 -75 216 -75 82 0 109 12 109 50 0 37 -27 50 -106 50 -95 0 -145 23 -174
80 -17 33 -20 59 -20 169 0 102 -4 138 -17 166 -16 33 -16 37 0 70 13 28 17
64 17 166 0 110 3 136 20 169 29 57 79 80 174 80 79 0 106 13 106 50 0 10 -7
26 -16 34 -21 21 -162 20 -223 -1z"/>
<path d="M806 1174 c-9 -8 -16 -24 -16 -34 0 -37 27 -50 101 -50 89 0 141 -24
169 -80 17 -33 20 -59 20 -169 0 -102 4 -138 17 -166 16 -33 16 -37 0 -70 -13
-28 -17 -64 -17 -166 0 -110 -3 -136 -20 -169 -28 -56 -80 -80 -169 -80 -74 0
-101 -13 -101 -50 0 -37 27 -50 104 -50 95 0 159 23 211 75 60 59 75 112 75
261 0 67 3 129 6 138 3 9 23 20 44 26 67 18 67 82 0 100 -21 6 -41 17 -44 26
-3 9 -6 71 -6 138 0 88 -5 136 -17 171 -21 63 -85 127 -148 148 -64 22 -188
23 -209 1z"/>
<path d="M316 974 c-9 -8 -16 -24 -16 -34 0 -36 27 -50 100 -50 73 0 100 14
100 50 0 36 -27 50 -100 50 -49 0 -73 -4 -84 -16z"/>
<path d="M616 974 c-9 -8 -16 -24 -16 -34 0 -44 22 -50 190 -50 131 0 161 3
174 16 20 20 20 48 0 68 -23 24 -325 24 -348 0z"/>
<path d="M316 774 c-9 -8 -16 -24 -16 -34 0 -44 22 -50 190 -50 131 0 161 3
174 16 20 20 20 48 0 68 -23 24 -325 24 -348 0z"/>
<path d="M796 774 c-9 -8 -16 -24 -16 -34 0 -36 27 -50 100 -50 73 0 100 14
100 50 0 36 -27 50 -100 50 -49 0 -73 -4 -84 -16z"/>
<path d="M316 574 c-9 -8 -16 -24 -16 -34 0 -36 27 -50 100 -50 73 0 100 14
100 50 0 36 -27 50 -100 50 -49 0 -73 -4 -84 -16z"/>
<path d="M616 574 c-9 -8 -16 -24 -16 -34 0 -44 22 -50 190 -50 131 0 161 3
174 16 20 20 20 48 0 68 -23 24 -325 24 -348 0z"/>
<path d="M316 374 c-20 -20 -20 -48 0 -68 23 -24 325 -24 348 0 20 20 20 48 0
68 -23 24 -325 24 -348 0z"/>
<path d="M796 374 c-9 -8 -16 -24 -16 -34 0 -36 27 -50 100 -50 73 0 100 14
100 50 0 36 -27 50 -100 50 -49 0 -73 -4 -84 -16z"/>
</g>
</svg>`;

export default codeSnippet;
